import { uniqBy } from 'lodash';
import { DataTreeAction, DataTreeTypes } from '../actions/dataTreeActions';
import { ApiStatus, INode } from '../../models';

export const initialDataTreeState: IDataTreeState = {
  loadingDatabasesStatus: ApiStatus.LOADING,
  loadingSchemasStatus: ApiStatus.LOADING,
  loadingTablesStatus: ApiStatus.LOADING,
  loadingColumnsStatus: ApiStatus.LOADING,
  loadingSelectStarStatus: ApiStatus.LOADING,
  nodes: null,
  selectStarData: null,
  hiddenNodes:[],
}

export interface IDataTreeState {
  loadingDatabasesStatus: ApiStatus;
  loadingSchemasStatus: ApiStatus;
  loadingTablesStatus: ApiStatus;
  loadingColumnsStatus: ApiStatus;
  loadingSelectStarStatus: ApiStatus;
  nodes: INode[] | null;
  selectStarData: any | null;
  hiddenNodes: string[];
}

export default function dataTreeReducer(
  state: IDataTreeState = initialDataTreeState,
  action: DataTreeAction): IDataTreeState
{

  let loadedKeyStatus = '';

  switch (action.type) {
    case DataTreeTypes.LOAD_DATABASES:
    case DataTreeTypes.LOADING_DATABASES:
      return {
        ...state,
        loadingDatabasesStatus: ApiStatus.LOADING
      };
    case DataTreeTypes.LOAD_SCHEMAS:
    case DataTreeTypes.LOADING_SCHEMAS:
      return {
        ...state,
        loadingSchemasStatus: ApiStatus.LOADING
      };
    case DataTreeTypes.LOAD_TABLES:
    case DataTreeTypes.LOADING_TABLES:
      return {
        ...state,
        loadingTablesStatus: ApiStatus.LOADING
      };
    case DataTreeTypes.LOAD_COLUMNS:
    case DataTreeTypes.LOADING_COLUMNS:
      return {
        ...state,
        loadingColumnsStatus: ApiStatus.LOADING
      };
    case DataTreeTypes.LOAD_SELECT_STAR:
    case DataTreeTypes.LOADING_SELECT_STAR:
      return {
        ...state,
        loadingSelectStarStatus: ApiStatus.LOADING
      };
    case DataTreeTypes.LOADING_DATABASES_FAILED:
      return {
        ...state,
        loadingDatabasesStatus: ApiStatus.FAILED
      };
    case DataTreeTypes.LOADING_SCHEMAS_FAILED:
      return {
        ...state,
        loadingSchemasStatus: ApiStatus.FAILED
      };
    case DataTreeTypes.LOADING_TABLES_FAILED:
      return {
        ...state,
        loadingTablesStatus: ApiStatus.FAILED
      };
    case DataTreeTypes.LOADING_COLUMNS_FAILED:
      return {
        ...state,
        loadingColumnsStatus: ApiStatus.FAILED
      };
    case DataTreeTypes.LOADING_SELECT_STAR_FAILED:
      return {
        ...state,
        loadingSelectStarStatus: ApiStatus.FAILED
      }
    case DataTreeTypes.LOADED_DATABASES:
      loadedKeyStatus = 'loadingDatabasesStatus';
    case DataTreeTypes.LOADED_SCHEMAS:
      loadedKeyStatus = loadedKeyStatus || 'loadingSchemasStatus';
    case DataTreeTypes.LOADED_TABLES:
      loadedKeyStatus = loadedKeyStatus || 'loadingTablesStatus';
    case DataTreeTypes.LOADED_COLUMNS:
      loadedKeyStatus = loadedKeyStatus || 'loadingColumnsStatus';
      const newNodes: INode[] = state.nodes ? state.nodes.concat(action.payload) : action.payload;
      return {
        ...state,
        nodes: uniqBy(newNodes, 'id'),
        [loadedKeyStatus]: ApiStatus.LOADED,
      }
    case DataTreeTypes.SET_HIDDEN_NODES:
      return {
        ...state,
        hiddenNodes:action.payload
      }
    case DataTreeTypes.LOADED_SELECT_STAR:
      loadedKeyStatus = loadedKeyStatus || 'loadingSelectStarStatus';
      let data: any = JSON.parse(action.payload);
      if (data) {
        data.value = {
          data: data.data,
          selected_columns: data.selected_columns,
        };
      }
      return {
        ...state,
        selectStarData: data,
        [loadedKeyStatus]: ApiStatus.LOADED,
      };
    default:
      return state;
  }
};
